const permissions = {
  'permissions-breadcrumbs': 'Permissions',
  'permissions-search-by': 'Search by name or display name...',
};

export default permissions;
